import { Container } from 'react-bootstrap';
import "../../Styles/yellowcalf.css/Receipt_invoice.css";
import Letterhead from '../../components/Letterhead';


export default function Receipt_invoice () {
  const executeDocumentPrint = () => {
    window.print();
  };

  return (
    <div className="billing-document-wrapper">
      {/* Official school letterhead at the top of every receipt */}
      <Letterhead subtitle="Invoice Receipt" />

      <div className="billing-header-label yc-no-print">
        <h1>Invoice</h1>
      </div>

      <Container fluid className="p-0">
        <div className="primary-receipt-container">
          <div className="company-branding-section">
            <div className="receipt-metadata-area">
              <h2>Invoice Receipt</h2>
              <p>Date 27-07-2020</p>
            </div>
          </div>

          <table className="financial-breakdown-table">
            <thead>
              <tr>
                <th>Invoice Item</th>
                <th>Amount</th>
                <th>Quantity</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="line-item-description-cell">
                  Monthly Subscription<br />Charges for July 2020
                </td>
                <td>$ 2700</td>
                <td>1</td>
                <td>$ 2700</td>
              </tr>
              <tr className="subtotal-summary-row">
                <td colSpan="2"></td>
                <td>Grand Total</td>
                <td>$ 2700</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="action-controls-section">
          <button
            className="print-trigger-button"
            onClick={executeDocumentPrint}
          >
            Print
          </button>
        </div>
      </Container>
    </div>
  );
}
